import React from 'react';
import { i18n } from 'config/locales';
import { Summary, AddressSummary, DateSummary } from 'components/Summary';
import foreign, { FOREIGN, FOREIGN_ACTIVITIES_FUTURE } from 'config/formSections/foreign';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';

import FutureBenefitPvq from './FutureBenefitPvq';

const sectionConfig = {
  key: FOREIGN_ACTIVITIES_FUTURE.key,
  section: FOREIGN.name,
  store: FOREIGN.store,
  subsection: FOREIGN_ACTIVITIES_FUTURE.name,
  storeKey: FOREIGN_ACTIVITIES_FUTURE.storeKey,
};
export class FutureActivity extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasFutureActivity: this.props.HasFutureActivity,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasFutureActivity = (values) => {
    this.update({
      HasFutureActivity: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const who = ((o.InterestTypes || {}).values || []).join(', ');
    const acquired = DateSummary(o.Acquired);
    const address = AddressSummary(o.Address, '');
    const summary = [who, address].reduce((prev, next) => {
      if (prev && next) {
        return <span>{`${prev} - ${next.props.children}`}</span>;
      }
      return prev;
    });

    return Summary({
      type: i18n.t('foreign.pvq.activities.collection.itemType.future'),
      index,
      left: who || address ? summary : '',
      right: acquired,
      placeholder: i18n.t('foreign.pvq.activities.collection.summary.future'),
    });
  };

  render() {
    const { errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    return (
      <div
        className="section-content future"
        data-section={FOREIGN.key}
        data-subsection={FOREIGN_ACTIVITIES_FUTURE.key}
      >
        <h1 className="section-header">{i18n.t('foreign.pvq.activities.direct.heading.title5')}</h1>
        <Branch
          name="has_interests"
         label={i18n.m('foreign.pvq.activities.futureTitle')}
          labelSize="h4"
          {...this.props.HasFutureActivity}
          warning
          onError={this.handleError}
          onUpdate={this.updateHasFutureActivity}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasFutureActivity"
        >
      
        </Branch>
        <Show when={this.props.HasFutureActivity.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t('foreign.activities.direct.collection.description')}
            appendMessage={i18n.t('foreign.pvq.activities.appendMessage')}
            appendLabel={i18n.t('foreign.activities.direct.collection.appendTitle')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <FutureBenefitPvq
              name="Item"
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
              applicantBirthdate={this.props.applicantBirthdate}
              peopleWhoKnowYou={this.props.peopleWhoKnowYou}
              formType={this.props.formType}
            />

          </Accordion>
        </Show>

      </div>
    );
  }
}

FutureActivity.defaultProps = {
  name: 'future',
  HasFutureActivity: {},
  List: {},
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'foreign',
  subsection: 'activities/future',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(FutureActivity, sectionConfig);
